const lang = {
    actionButton: {
        confirm: 'ОК',
        cancel: 'Отмена',
    },
};
export default lang;
